import { Injectable, Injector } from '@angular/core';
import { Constants } from "./models/constants";
import {environment} from "../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class Config {
  BASE_URL: string;
  DASHBOARD_URL: string;
  SQLITE_DB_NAME: string;

  FIRST_STEPS_APP: number;
  LIBRARY_READING_SAMPLE: number;
  LIBRARY_READING_SAMPLE_OVERVIEW: number;
  LIBRARY_READING_SAMPLE_ELEARNING: number;
x
  // Auth
  LOGIN_API: string;
  LOGOUT_API: string;
  ME_API: string;
  UPDATE_PROFILE_API: string;
  REFRESH_API: string;

  // User
  USER_BY_ID: string;
  USER_BY_EMAIL: string;
  USER_BY_USERNAME: string;

  EDOC_CATEGORY_API: string;
  EDOC_LIST_ITEMS_API: string;
  EDOC_SHOW_ITEM_API: string;
  EDOC_MANAGER_API: string;
  EDOC_MEDIA_CATEGORY: string;
  EDOC_MEDIA: string;

  DASHBOARD_PW_RESET: string;
  DASHBOARD_KEY_CHECK: string;
  DASHBOARD_REGISTER_API: string;

  // System
  SYSTEM_PING_API: string;

  // DB tables
  TABLE_ADMINISTRATION = 'administration';
  TABLE_EDOCS = 'edocs';

  // Jobs
  JOB_DESCRIPTIONS: object = {}

  constructor(
    private injector: Injector,
  ) {
    this.initializeSettings();
    this.initializeJobDescriptions()
  }

  public initializeJobDescriptions() {
    let sortedNames = [
      'Pflegefachkraft',
      'Pflegehilfskraft / Pflegeassistenz / Pflegehelfer',
      'Praxisanleiter',
      'Pflegedienstleitung',
      'Wohnbereichsleitung / Stationsleitung',
      'Qualitätsbeauftragter',
      'Wundexperte',
      'Wundtherapeut',
      'Wundmanager',
      'Gerontopsychiatrische Fachkraft',
      'Palliativfachkraft',
      'Betreuungsassistenz',
      'Sozialarbeiter',
      'Sozialpädagoge',
      'Ergotherapeut',
      'Physiotherapeut',
      'Logopäde',
      'Hauswirtschaftskraft / Reinigungskraft',
      'Wäschereimitarbeiter',
      'Servicekraft',
      'Leitung Hauswirtschaft',
      'Koch/Köchin',
      'Küchenhilfe',
      'Küchenleitung',
      'Einrichtungsleitung',
      'Heimleitung',
      'Personalverwaltung',
      'Medikamentenverantwortlicher',
      'Hausmeister, Haustechniker, Gärtner',
      'Sekretariat',
      'Ausbildungskoordinator',
      'Auszubildender'
    ];

    this.JOB_DESCRIPTIONS = sortedNames.sort();
  }

  public async initializeSettings() {
    // settings wird nicht verwendet
    // let settings = JSON.parse(localStorage.getItem(Constants.SETTINGS)) || {};

    let count = 0;
    // repeat each second until document is ready?
    if (count == 0) // da sonst ewig
      setInterval(() => {
        let urls = JSON.parse(localStorage.getItem(Constants.URLS)) || {};

        // console.log("URLS #", urls);
        if (urls.hasOwnProperty('ecockpitUrl')) {
          this.BASE_URL = urls.ecockpitUrl;

          if (urls.ecockpitUrl.length > 5 && count === 0) {
            //console.log("URLS and count #", urls);
            this.initializeApis();
            count++;
          }
        }

      }, 1000);

    this.SQLITE_DB_NAME = 'muriapp_db';

    this.initializeApis();
  }

  private initializeApis() {
    this.BASE_URL = environment.ecockpitUrl;
    this.DASHBOARD_URL = environment.dashboardUrl;

    this.FIRST_STEPS_APP = environment.firstStepsAppId;
    this.LIBRARY_READING_SAMPLE = environment.readingSampleLibraryId;
    this.LIBRARY_READING_SAMPLE_OVERVIEW = environment.readingSampleLibraryOverviewId;
    this.LIBRARY_READING_SAMPLE_ELEARNING = environment.readingSampleElearningId;

    // Auth
    this.LOGIN_API = `${this.BASE_URL}api/auth/login`;
    this.LOGOUT_API = `${this.BASE_URL}api/auth/logout`;
    this.ME_API = `${this.BASE_URL}api/auth/me`;
    this.UPDATE_PROFILE_API = `${this.BASE_URL}api/auth/updateProfile`;
    this.REFRESH_API = `${this.BASE_URL}api/auth/refresh`;

    // User
    this.USER_BY_ID = `${this.BASE_URL}api/user/byId`;
    this.USER_BY_EMAIL = `${this.BASE_URL}api/user/byEmail`;
    this.USER_BY_USERNAME = `${this.BASE_URL}api/user/byUsername`;

    // System
    this.SYSTEM_PING_API = `${this.BASE_URL}api/system/ping`;

    // eDocs
    this.EDOC_CATEGORY_API = `${this.BASE_URL}api/edocmanager/list_edocsByCategory/?orderBy=name&parentId=`;
    this.EDOC_LIST_ITEMS_API = `${this.BASE_URL}api/edocmanager/list_edocs?category=`;
    this.EDOC_SHOW_ITEM_API = `${this.BASE_URL}api/edocmanager/details/`;
    this.EDOC_MANAGER_API = `${this.BASE_URL}api/edocmanager/`;
    this.EDOC_MEDIA_CATEGORY = `${this.BASE_URL}media/customer_category/`;
    this.EDOC_MEDIA = `${this.BASE_URL}media/`;

    // DASHBOARD
    this.DASHBOARD_KEY_CHECK = `${this.DASHBOARD_URL}api/elearning/token/`;
    this.DASHBOARD_PW_RESET = `${this.DASHBOARD_URL}api/elearning/password-reset/`;
    this.DASHBOARD_REGISTER_API = `${this.DASHBOARD_URL}api/elearning/register/`;
  }
}

